import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";

import {
  type PatchChartingNoncomplianceRequest,
  PatchChartingNoncomplianceRequestSchema,
  type PatchChartingNoncomplianceResponse,
  PatchChartingNoncomplianceResponseSchema,
} from "./schema";

interface PatchChartingNoncomplianceParams {
  chartingNoncomplianceId: string;
}

export function usePatchChartingNoncompliances(
  params: PatchChartingNoncomplianceParams,
  options: UseMutationOptions<
    PatchChartingNoncomplianceResponse,
    AxiosError,
    PatchChartingNoncomplianceRequest
  > = {}
): UseMutationResult<
  PatchChartingNoncomplianceResponse,
  AxiosError,
  PatchChartingNoncomplianceRequest
> {
  const { chartingNoncomplianceId } = params;

  return useMutation({
    mutationFn: async (data: PatchChartingNoncomplianceRequest) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/charting-noncompliances/${chartingNoncomplianceId}`,
        data,
        requestSchema: PatchChartingNoncomplianceRequestSchema,
        responseSchema: PatchChartingNoncomplianceResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.PATCH_CHARTING_NONCOMPLIANCE_FAILURE,
    },
    ...options,
  });
}
